import {
	Button,
	Checkbox,
	Divider,
	Grid,
	Paper,
	Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import xlsx from '../images/xlsx.png';
import pdf from '../images/pdf.png';
import WebLogo from '../../../../assets/logos/websitelogo.svg';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { utils, writeFile } from 'xlsx';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {
	borderColor,
	buttonStyles,
	button_Styles1,
	csvStyle,
	filterSectionStyle,
	grid_Button_Style,
	grid_Icon_Style,
	headerSection,
	pdfStyle,
	textStyling,
	titleWithTextfield,
	headerStyling,
} from './GeneralStyles';

import {
	getChargesReport,
	getVisit,
	getPracticeStaff,
	postVisitDatalist,
	getPatientList,
} from '../../../../app/services/api/apiManager';
import dayjs from 'dayjs';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import PatientReport from '../PatientReport';
import CircularProgress from '@mui/material/CircularProgress';

// Dispatch Section
// import { useStateValue } from '../../../services/state/State';
// import { actions } from '../../../services/state/Reducer';

const CR = () => {
	// const [{practice,practicestats,batches,locations,visits,providers},dispatch] = useStateValue();

	// All Api Data State
	const [allProviders, setAllProviders] = useState([]);
	const [allVisits, setAllVisits] = useState([]);
	const [filterPatient, setFilterPatient] = useState([]);
	const [allPatientsData, setAllPatientsData] = useState([]);

	const practiceID = localStorage.getItem('practice_id');

	// Filter Data
	const [filterationData, setFilterationData] = useState([]);
	const [showText, setShowText] = useState([]);

	// Loader State
	const [isLoading, setIsLoading] = useState(true);

	const showPracticeData = async () => {
		const response = await getPracticeStaff();
		if (response?.status === 200) {
			dispatch({ type: actions.SET_PROVIDERS, payload: response?.data });
		} else dispatch({ type: actions.SET_PROVIDERS, payload: [] });
	};

	// Export Data State
	const [exportData, setExportData] = useState(true);

	// Navigate to Page State
	const [currentPage, setCurrentPage] = useState(true);

	// All Api Data State
	const [apiData, setApiData] = useState([]);

	// Fetch Api To Parctice Staff Data State
	const [allfilterData, setAllFilterData] = useState([]);

	const [pdfUrl, setPdfUrl] = useState('');

	// Handle Date Value States

	const [dateValue, setDateValue] = useState({
		fromDate: dayjs().startOf('month'), // Get the start of the current month
		toDate: dayjs(),
	});

	// Formate date
	const formatFromDate = dayjs(dateValue.fromDate).format('YYYY-MM-DD');
	const formatToDate = dayjs(dateValue.toDate).format('YYYY-MM-DD');

	// Target Date Value Function
	const handleDateValue = (name, date) => {
		setDateValue({
			...dateValue,
			[name]: date,
		});
		getVisitListData(filterData);
	};

	// Handle Patient Name State
	const [selectPatient, setSelectPatient] = useState([]);

	// Handle Select Value States
	const [selectValue, setSelectValue] = useState({
		status: '',
		provider: '',
	});

	// Target Select Value Function
	const handleSelectValue = (event) => {
		setSelectValue({
			...selectValue,
			[event.target.name]: event.target.value,
		});
		getVisitListData(filterData);
	};

	// Reset All Values
	const resetValues = () => {
		setSelectValue({
			status: '',
			provider: '',
		});
		setSelectPatient([]);
		setDateValue({
			fromDate: '',
			toDate: '',
		});
		setExportData(true);
		setFilterationData([]);
		setShowText([]);
		getVisitListData({ practice_id: practiceID });
	};

	// Define table styles
	const styles = {
		// cellPadding: 1.5,
		fontSize: 10,
		halign: 'center',
		valign: 'middle',
		// fillColor: '#EEEEEE', // Background color of table cells
		// textColor: '#000000', // Text color of table cells
		fontStyle: 'normal', // Font style of table cells
		// overflow: 'ellipsize', // How to handle overflowing content
		lineWidth: 0.1, // Width of table borders
		lineColor: '#000000', // Color of table borders
		cellWidth: 'auto', // Use auto column width
		// minCellWidth: 40, // Minimum width for each cell
	};

	// Download PDF All Data
	const downloadAllDataPDF = () => {
		// Create a new PDF document
		const doc = new jsPDF({ orientation: 'landscape' });
		const pageWidth = doc.internal.pageSize.getWidth();
		const pageHeight = doc.internal.pageSize.getHeight();
		const title = 'Visit History';
		const textWidth =
			(doc.getStringUnitWidth(title) * doc.internal.getFontSize()) /
			doc.internal.scaleFactor;
		const xPos = (pageWidth - textWidth) / 2;

		// Add the title
		doc.setFont('helvetica', 'bold');
		doc.text(title, xPos, 15);
		doc.setFont('helvetica', 'normal');

		// Get a unique list of Patients
		const uniquePatients = [
			...new Set(
				filterPatient?.map(
					(item) => item?.patient?.Fname + ' ' + item?.patient?.Lname
				)
			),
		];

		let currentY = 30; // Initial Y position for the content after the title
		const margin = 10;

		uniquePatients.forEach((patientName, index) => {
			// Add the patient name as a title for each section
			const patientTitle = `Patient: ${patientName}`;
			const patientTitleHeight = doc.getTextDimensions(patientTitle).h;
			const requiredHeight = patientTitleHeight + 5; // Height needed for patient title

			// Filter visits for the current patient
			const patientVisits = filterPatient?.filter(
				(item) =>
					item?.patient?.Fname + ' ' + item?.patient?.Lname === patientName
			);

			// Create table data for the current patient
			const bodyData = patientVisits?.map((item, index) => [
				index + 1,
				item?.patient?.Lname + ', ' + item?.patient?.Fname,
				item?.Gender == 'M'
					? 'Male'
					: item?.Gender == 'F'
						? 'Female'
						: item?.Gender == 'o' || item?.Gender == 'O'
							? 'Other'
							: '',
				item?.provider === ', ' ? '' : item?.provider,
				item?.VisitStatus === 'A'
					? 'Approved'
					: item?.VisitStatus === 'B'
						? 'Billed'
						: item?.VisitStatus === 'D'
							? 'Drafted'
							: 'Other',
				item?.location,
				item?.payer_name,
				// item?.refid,
				item?.referring === ', ' ? '' : item?.referring,
				item?.visit_cpts
					?.map((data) =>
						data?.CPTCode === null ? 'here' : data?.CPTCode + ' '
					)
					.join(', '),
				`${item?.Dxcode1 === null ? '' : item?.Dxcode1 + ','}${item?.Dxcode2 === null ? '' : item?.Dxcode2 + ','} ${item?.Dxcode3 === null ? '' : item?.Dxcode3 + ','} ${item?.Dxcode4 === null ? '' : item?.Dxcode4 + ','} ${item?.Dxcode5 === null ? '' : item?.Dxcode5 + ','} ${item?.Dxcode6 === null ? '' : item?.Dxcode6 + ','} ${item?.Dxcode7 === null ? '' : item?.Dxcode7 + ','} ${item?.Dxcode8 === null ? '' : item?.Dxcode8 + ','} ${item?.Dxcode9 === null ? '' : item?.Dxcode9 + ','} ${item?.Dxcode10 === null ? '' : item?.Dxcode10 + ','} ${item?.Dxcode11 === null ? '' : item?.Dxcode11 + ','} ${item?.Dxcode12 === null ? '' : item?.Dxcode12 + ','} `,
				item?.BatchName,
				dayjs(item?.VisitDate).format('MM-DD-YYYY'),
			]);

			// Calculate required height for the table
			const tableHeight = bodyData.length * 10 + 10; // Assuming each row height is 10 and header height is 10
			const totalRequiredHeight = requiredHeight + tableHeight + margin;

			// Check if there is enough space on the current page, if not, add a new page
			if (currentY + totalRequiredHeight > pageHeight - margin) {
				doc.addPage();
				currentY = margin;
			}

			// Add patient name
			doc.setFont('helvetica', 'bold');
			doc.text(patientTitle, 14, currentY);
			currentY += patientTitleHeight + 5; // Update Y position for the table

			// Add the table for the current patient
			doc.autoTable({
				startY: currentY,
				head: [
					[
						// Column Fields Name here
						'Serial No.',
						'Patient',
						'Sex',
						'Provider',
						'Visit Status',
						'Location',
						'Payer',
						// 'Ref #',
						'Referring Physician',
						'Charge Codes',
						'ICDs',
						'Batch',
						'Visit Date',
					],
				],
				body: bodyData,
				styles: styles,
				headStyles: {
					fillColor: '#CCCCCC', // Background color of header row
					textColor: '#000000', // Text color of header row
					fontStyle: 'bold', // Font style of header row
				},
				margin: { top: 0, bottom: 0 },
				didDrawPage: function (data) {
					currentY = data.cursor.y; // Update current Y position after drawing the table
				},
			});
			currentY = doc.previousAutoTable.finalY + margin; // Update currentY to the end of the last table
		});

		// Save the PDF document
		doc.save('Charge Report.pdf');
		setShowText(filterPatient);
	};

	// Function - Download CSV File with All Data
	const downloadAllCSV = () => {
		const columns = [
			[
				// Column Field Name Here
				'Patient',
				'Sex',
				'Provider',
				'Visit Status',
				'Location',
				'Payer',
				'Referring Physician',
				'Charge Codes',
				'ICDs',
				'Batch',
				'Visit Date',
			],
		];

		var workbook = utils.book_new();
		var worksheet = utils.json_to_sheet([]);

		utils.sheet_add_aoa(worksheet, columns);

		// Assuming allVisits is an array of objects
		filterPatient?.forEach((row, index) => {
			utils.sheet_add_json(
				worksheet,
				[
					[
						row?.patient.Lname + ', ' + row?.patient.Fname,
						row?.Gender == 'M'
							? 'Male'
							: row?.Gender == 'F'
								? 'Female'
								: row?.Gender == 'o' || row?.Gender == 'O'
									? 'Other'
									: '',
						row?.provider === ', ' ? '' : row?.provider,
						row?.VisitStatus === 'A'
							? 'Approved'
							: row?.VisitStatus === 'B'
								? 'Billed'
								: row?.VisitStatus === 'D'
									? 'Drafted'
									: 'Other',
						row?.location,
						row?.payer_name,
						row?.referring === ', ' ? '' : row?.referring,
						row?.visit_cpts
							?.map((data) =>
								data?.CPTCode === null ? 'here' : data?.CPTCode + ' '
							)
							.join(', '),
						`${row?.Dxcode1 === null ? '' : row?.Dxcode1 + ','}${row?.Dxcode2 === null ? '' : row?.Dxcode2 + ','} ${row?.Dxcode3 === null ? '' : row?.Dxcode3 + ','} ${row?.Dxcode4 === null ? '' : row?.Dxcode4 + ','} ${row?.Dxcode5 === null ? '' : row?.Dxcode5 + ','} ${row?.Dxcode6 === null ? '' : row?.Dxcode6 + ','} ${row?.Dxcode7 === null ? '' : row?.Dxcode7 + ','} ${row?.Dxcode8 === null ? '' : row?.Dxcode8 + ','} ${row?.Dxcode9 === null ? '' : row?.Dxcode9 + ','} ${row?.Dxcode10 === null ? '' : row?.Dxcode10 + ','} ${row?.Dxcode11 === null ? '' : row?.Dxcode11 + ','} ${row?.Dxcode12 === null ? '' : row?.Dxcode12 + ','} `,
						row?.BatchName,
						dayjs(row?.VisitDate).format('MM-DD-YYYY'),
					],
				],
				{ origin: `A${index + 2}`, skipHeader: true }
			);
		});

		utils.book_append_sheet(workbook, worksheet, 'Report');
		writeFile(workbook, 'Charge Report.xlsx');
		setShowText(filterPatient);
	};

	// Function -- Download PDF Data
	const handleDownloadPdf = async () => {
		downloadAllDataPDF();
	};

	// Function -- Download CSV Data
	const handleDownloadCSV = () => {
		downloadAllCSV();
	};

	// Function For Getting API Provider Data

	const getProviders = async () => {
		try {
			const response = await getPracticeStaff();
			if (response?.status === 200) {
				setAllProviders(response?.data);
			}
		} catch (error) {
			console.error('Error fetching Provider:', error);
		}
	};

	// Patient Api function
	const getPatientData = async () => {
		try {
			const response = await getPatientList(practiceID);
			setAllPatientsData(response?.data);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	// Function For Getting API Visits Data, also using chargelist
	const getVisitListData = async (data) => {
		try {
			const response = await postVisitDatalist(data);
			if (response?.status === 200 || response?.status === 201) {
				setAllVisits(response?.data);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	// get data Through Post method
	const filterData = {
		practice_id: practiceID,
		// ...(selectPatient && { in_PatientSearch: selectPatient }),
		...(formatFromDate !== 'Invalid Date' && { in_DateFrom: formatFromDate }),
		...(formatToDate !== 'Invalid Date' && { in_DateTo: formatToDate }),
		...(selectValue.status && { in_VisitStatus: selectValue?.status }),
		...(selectValue.provider && { in_Provider: selectValue?.provider }),
	};

	useEffect(() => {
		if (selectPatient && selectPatient.length > 0) {
			// Filter data when selectPatient is not empty
			const filtered = allVisits?.filter((item) =>
				selectPatient.includes(item?.patient_id)
			);
			setFilterPatient(filtered);
		} else {
			// If selectPatient is empty, set all data
			setFilterPatient(allVisits);
		}
	}, [selectPatient, allVisits]);

	useEffect(() => {
		const fetchData = async () => {
			try {
				await getProviders();
				// await getVisits();
				await getVisitListData(filterData);

				await getPatientData();

				// Check if all data arrays are not empty
				if (allProviders && allVisits && allPatientsData) {
					setIsLoading(false); // Stop loader if all data is available
				}
			} catch (error) {
				console.error('Error fetching data:', error);
				setIsLoading(false); // Stop loader in case of error
			}
		};

		fetchData();
	}, [selectValue, dateValue]);

	return currentPage ? (
		isLoading ? (
			// Maxchart Logo instead of Loader
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					height: '80vh',
				}}
			>
				<Box
					sx={{
						opacity: 0 /* Initially hide the logo */,
						animation:
							'fadeInOut 2s linear infinite' /* Apply the fade-in and fade-out animation */,
					}}
				>
					<img className="logo" src={WebLogo} alt="Website Logo" />
				</Box>
			</Box>
		) : (
			// Content Here...
			<Paper
				elevation={1}
				sx={{
					margin: '1rem',
				}}
			>
				<Box
					sx={{
						flexGrow: 1,
						// height: {
						// 	lg: '30vh',
						// 	md: '40vh',
						// 	sm: '55vh',
						// 	xs: '90vh',
						// },
						height: {
							xl: '55vh',
							lg: '35vh',
							md: '52vh',
							sm: '65vh',
							xs: '100vh',
						},
						// border: '1px solid black',
					}}
				>
					<Box
						style={headerStyling}
						sx={{
							padding: {
								xl: '0.5rem',
								lg: '0.5rem',
								md: '0.5rem',
								sm: '0.5rem',
								xs: '0.3rem',
							},
						}}
					>
						<KeyboardBackspaceIcon
							sx={{
								fontSize: '1.5rem',
								color: 'black',
								bgcolor: 'white',
								borderRadius: '1rem',
								cursor: 'pointer',
								'&:hover': {
									bgcolor: 'black',
									color: 'white',
								},
							}}
							onClick={() => {
								setCurrentPage(false);
							}}
						/>
						<Typography style={headerSection}> Charge Report</Typography>
					</Box>
					<Grid container item sx={{ padding: '15px' }}>
						<Grid
							container
							item
							spacing={3}
							sx={{
								p: '20px',
								background: '#F6F6F6',
								margin: '1px',
								// border: '1px solid red',
								borderRadius: '6px',
							}}
						>
							<Grid item xs={12} md={12} lg={12}>
								<Grid container spacing={2}>
									<Grid item xl={2.4} lg={2.4} md={3} sm={6} xs={12}>
										<Box style={titleWithTextfield}>
											<Typography fontWeight={'bold'} fontSize={'14px'}>
												Patient
											</Typography>
											{/*<FormControl style={borderColor} size="small">
												<InputLabel id="patient-label">Patient</InputLabel>
												<Select
													labelId="patient-label"
													id="patient"
													label="Patient"
													multiple
													value={selectPatient}
													onChange={(event) =>
														setSelectPatient(event.target.value)
													}
													renderValue={(selected) => {
														const selectedNames = selected.map((id) => {
															const patientData = allPatientsData?.find(
																(items) => items?.patient_id == id
															);
															return patientData ? `${items?.Name}` : '';
														});
														return selectedNames.join(', ');
													}}
													MenuProps={{
														PaperProps: {
															style: {
																height: '200px',
																width: '130px',
																overflowY: 'auto',
																overflowX: 'auto',
																scrollbarWidth: 'thin',
																scrollbarColor: 'dark',
																msOverflowStyle: 'none',
																WebkitOverflowScrolling: 'touch',
															},
														},
													}}
												>
													{allPatientsData?.map((items, index) => (
														<MenuItem key={index} value={items?.patient_id}>
															<Checkbox
																checked={selectPatient.includes(
																	items?.patient_id
																)}
															/>
															{items?.Name}
														</MenuItem>
													))}
												</Select>
											</FormControl>*/}

											<FormControl style={borderColor} size="small">
												<InputLabel id="patient-label">Patient</InputLabel>
												<Select
													labelId="patient-label"
													id="patient"
													label="Patient"
													multiple
													value={selectPatient}
													onChange={(event) =>
														setSelectPatient(event.target.value)
													}
													// renderValue={(selected) => {
													// 	const selectedNames = selected.map((id) => {
													// 		const patientData = allPatientsData?.find(
													// 			(item) => item?.patient_id === id
													// 		);
													// 		return patientData ? patientData?.Name : '';
													// 	});
													// 	return selectedNames
													// 		.filter((name) => name)
													// 		.join(', '); // Ensures no empty strings are included
													// }}
													renderValue={(selected) => {
														const selectedNames = selected
															?.map((id) => {
																const patientData = allPatientsData?.find(
																	(item) => item?.patient_id === id
																);
																return patientData ? patientData?.Name : '';
															})
															.filter((name) => name); // Filter out any empty strings

														// If only one patient is selected, display the name
														if (selectedNames.length === 1) {
															return selectedNames[0];
														}
														// If more than one patient is selected, display "1 + more"
														else if (selectedNames.length > 1) {
															return `${selectedNames[0]} + ${selectedNames.length - 1} more`;
														}
														// In case no patient is selected
														else {
															return '';
														}
													}}
													MenuProps={{
														PaperProps: {
															style: {
																maxHeight: '300px',
																width: '130px',
																overflowY: 'auto',
																scrollbarWidth: 'thin',
																scrollbarColor: 'dark',
																msOverflowStyle: 'none',
																WebkitOverflowScrolling: 'touch',
															},
														},
													}}
												>
													{allPatientsData?.map((item, index) => (
														<MenuItem key={index} value={item?.patient_id}>
															<Checkbox
																checked={selectPatient.includes(
																	item?.patient_id
																)}
															/>
															{item?.Name}
														</MenuItem>
													))}
												</Select>
											</FormControl>
										</Box>
									</Grid>
									<Grid item xl={2.4} lg={2.4} md={3} sm={6} xs={12}>
										<Box style={titleWithTextfield}>
											<Typography fontWeight={'bold'} fontSize={'14px'}>
												From Date
											</Typography>
											<FormControl style={borderColor}>
												<LocalizationProvider dateAdapter={AdapterDayjs}>
													<DatePicker
														value={dateValue.fromDate}
														name="fromDate"
														size="small"
														slotProps={{ textField: { size: 'small' } }}
														onChange={(event) =>
															handleDateValue('fromDate', event)
														}
													/>
												</LocalizationProvider>
											</FormControl>
										</Box>
									</Grid>
									<Grid item xl={2.4} lg={2.4} md={3} sm={6} xs={12}>
										<Box style={titleWithTextfield}>
											<Typography fontWeight={'bold'} fontSize={'14px'}>
												To Date
											</Typography>
											<FormControl style={borderColor}>
												<LocalizationProvider dateAdapter={AdapterDayjs}>
													<DatePicker
														value={dateValue.toDate}
														name="toDate"
														size="small"
														slotProps={{ textField: { size: 'small' } }}
														disableFuture={true}
														onChange={(event) =>
															handleDateValue('toDate', event)
														}
													/>
												</LocalizationProvider>
											</FormControl>
										</Box>
									</Grid>
									<Grid item xl={2.4} lg={2.4} md={3} sm={6} xs={12}>
										<Box style={titleWithTextfield}>
											<Typography fontWeight={'bold'} fontSize={'14px'}>
												Status
											</Typography>

											<FormControl style={borderColor} size="small">
												<InputLabel id="demo-simple-select-label">
													Status
												</InputLabel>
												<Select
													labelId="demo-simple-select-label"
													id="demo-simple-select"
													value={selectValue.status}
													label="Status"
													name="status"
													onChange={(event) => handleSelectValue(event)}
												>
													<MenuItem value={''}>Clear Status</MenuItem>
													<MenuItem value={'A'}>Approved</MenuItem>
													<MenuItem value={'B'}>Billed</MenuItem>
													<MenuItem value={'D'}>Drafted</MenuItem>
													<MenuItem value={'O'}>Other</MenuItem>
												</Select>
											</FormControl>
										</Box>
									</Grid>
									<Grid item xl={2.4} lg={2.4} md={3} sm={6} xs={12}>
										<Box style={titleWithTextfield}>
											<Typography fontWeight={'bold'} fontSize={'14px'}>
												Provider
											</Typography>
											<FormControl style={borderColor} size="small">
												<InputLabel id="demo-simple-select-label">
													Provider
												</InputLabel>
												<Select
													labelId="demo-simple-select-label"
													id="demo-simple-select"
													label="Provider"
													name="provider"
													value={selectValue.provider}
													onChange={(event) => handleSelectValue(event)}
													MenuProps={{
														PaperProps: {
															style: {
																maxHeight: '300px',
																width: '160px',
																overflowY: 'auto',
																scrollbarWidth: 'thin',
																scrollbarColor: 'dark',
																msOverflowStyle: 'none',
																WebkitOverflowScrolling: 'touch',
															},
														},
													}}
												>
													<MenuItem value={''}> Clear Filter </MenuItem>
													{allProviders?.map((item, index) => {
														return (
															<MenuItem key={index} value={item?.id}>
																{item?.Lname + ', ' + item?.Fname}
															</MenuItem>
														);
													})}
												</Select>
											</FormControl>
										</Box>
									</Grid>
								</Grid>
							</Grid>

							<Grid item md={3} lg={2} style={grid_Button_Style}>
								<Box
									sx={{
										display: 'flex',
										marginLeft: {
											lg: '2rem',
											md: '0rem',
										},
										marginTop: {
											lg: '0rem',
											xs: '1rem',
										},
									}}
								>
									{/*<Button
							variant="contained"
							// style={button_Styles1}
							onClick={() => searchValuesFilter()}
						>
							{' '}
							Search{' '}
									</Button> */}
									<Button
										variant="contained"
										size="small"
										sx={{
											marginBottom: {
												xl: '0px',
												lg: '0px',
												md: '0px',
												sm: '0px',
												xs: '1rem',
											},
											marginLeft: {
												xl: '0px',
												lg: '0px',
												md: '0px',
												sm: '0px',
												xs: '1.5rem',
											},
											padding: '0.5rem 1.5rem',
											textTransform: 'capitalize',
											letterSpacing: '0.1rem',
											backgroundColor: '#ED2828',
										}}
										disabled={
											selectPatient.length != 0 ||
											dateValue.fromDate ||
											dateValue.toDate ||
											selectValue.status ||
											selectValue.provider
												? false
												: true
										}
										onClick={() => {
											resetValues();
										}}
									>
										{' '}
										Reset{' '}
									</Button>
								</Box>
							</Grid>
							<Grid item md={2} lg={2} style={grid_Icon_Style}>
								<Box
									sx={{
										display: 'flex',
										gap: '1rem',
										ml: {
											lg: '0rem',
											xs: '1.5rem',
										},
									}}
								>
									<Box
										component={'img'}
										src={xlsx}
										style={csvStyle}
										onClick={() => {
											// Download CSV File Format Data
											handleDownloadCSV();
										}}
									></Box>

									<Box
										component={'img'}
										src={pdf}
										style={pdfStyle}
										onClick={() => {
											// Download Pdf File Format Data
											handleDownloadPdf();
										}}
									></Box>
								</Box>
							</Grid>
						</Grid>
					</Grid>
				</Box>
				<Divider />
				<Box
					style={filterSectionStyle}
					sx={{
						height: {
							xl: '55vh',
							lg: '50vh',
							md: '32vh',
							sm: '20vh',
							xs: '10vh',
						},
					}}
				>
					<Grid container>
						<Grid item xs={12}>
							{showText?.length > 0 ? null : (
								<Typography
									variant="body1"
									style={textStyling}
									sx={{
										fontSize: {
											xl: '20px',
											lg: '20px',
											md: '16px',
											sm: '12px',
											xs: '12px',
										},
									}}
									disabled
								>
									Please apply filter to get reports
								</Typography>
							)}
						</Grid>
					</Grid>
				</Box>

				{pdfUrl ? (
					<div style={{ marginTop: '20px' }}>
						<iframe src={pdfUrl} width="100%" height="600px" title="PDF" />
					</div>
				) : (
					''
				)}
			</Paper>
		)
	) : (
		<PatientReport />
	);
};

export default CR;
